/**
 * Operating-system detection from the user agent, replacing ngx-device-detector
 * (37 KB in the main bundle for this one check).
 *
 * The names and the order they are tried in match ngx-device-detector 3.0, so
 * the checkout `WebSource` sent to the API ("Website", "<os> App") is unchanged:
 * the first rule that matches wins, which is why Android is tried before Linux
 * (Android user agents contain "Linux") and Mac excludes iOS devices.
 */
type OsRule = [os: string, test: (ua: string) => boolean];

const WINDOWS_PHONE = /\bWindows Phone\b/;
const IOS_DEVICE = /\biPad\b|\biPhone\b|\biPod\b/;

const OS_RULES: OsRule[] = [
  ['Windows', (ua) => (/\bWindows|(Win\d\d)\b/.test(ua) || /\bWin 9x\b/.test(ua)) && !WINDOWS_PHONE.test(ua)],
  ['Mac', (ua) => /\bMac OS\b/.test(ua) && !IOS_DEVICE.test(ua) && !WINDOWS_PHONE.test(ua)],
  ['iOS', (ua) => IOS_DEVICE.test(ua) && !WINDOWS_PHONE.test(ua)],
  ['Android', (ua) => /\bAndroid\b/.test(ua) && !WINDOWS_PHONE.test(ua)],
  ['Linux', (ua) => /\bLinux\b/.test(ua)],
  ['Unix', (ua) => /\bUNIX\b/.test(ua)],
  ['Firefox-OS', (ua) => /\bFirefox\b/.test(ua) && /Mobile\b/.test(ua)],
  ['Chrome-OS', (ua) => /\bCrOS\b/.test(ua)],
  ['Windows-Phone', (ua) => /\bIEMobile\b/.test(ua) || WINDOWS_PHONE.test(ua)],
];

export function detectOs(userAgent: string = navigator.userAgent): string {
  const ua = userAgent || '';
  const match = OS_RULES.find(([, test]) => test(ua));
  return match ? match[0] : 'Unknown';
}

export interface DeviceInfo {
  userAgent: string;
  os: string;
}

export function getDeviceInfo(): DeviceInfo {
  const userAgent = navigator.userAgent;
  return { userAgent, os: detectOs(userAgent) };
}
